import { OctTabMenu } from "@oceantech/oceantech-ui";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { ModalBaseProps } from "../../../utils/models";
import SignatureEmployee from "./SignatureEmployee";
import SignatureForm from "./SignatureForm";

type Props = ModalBaseProps & {};

const SignatureModal = ({ open, onClose }: Props) => {
	const [activeTab, setActiveTab] = useState<string | null>(null);

	return (
		<Modal show={open} size="xl" centered onHide={onClose}>
			<Modal.Header className="py-3" closeButton>
				<Modal.Title>Thông tin phiếu ký</Modal.Title>
			</Modal.Header>

			<Modal.Body className="bg-white">
				<OctTabMenu
					danhsachTabs={[
						{
							title: "Danh sách ký phiếu",
							component: <SignatureForm />,
						},
						{
							title: "Danh sách nhân viên ký số",
							component: <SignatureEmployee />,
						},
					]}
					activeTab={activeTab}
					onTabChange={(tab) => {
						setActiveTab(tab);
					}}
				/>
			</Modal.Body>
			<Modal.Footer>
				<Button className="btn-danger" onClick={onClose}>
					Đóng
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default SignatureModal;
